/** Whether a bill has a table assigned (floor table id or valid table code). */
export function billHasAssignedTable(bill) {
  if (!bill) return false;
  if (bill.restaurant_table_id) return true;
  const code = String(bill.table_code || "").trim();
  return code.length > 0 && code !== "—" && code !== "-";
}

/** Dine-in orders require a table before kitchen send. */
export function dineInOrder(bill) {
  return (bill?.order_type || "DI") === "DI";
}
